import { Platform, Orientation } from "consts";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.LANDSCAPE]: "75%",
  },
};

export const ConatinerMargin = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "140",
    [Orientation.LANDSCAPE]: "130",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "147",
    [Orientation.LANDSCAPE]: "150",
  },
};

export const StarSize = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 50,
    [Orientation.LANDSCAPE]: 50,
  },
};

export const StarInnerMargin = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 10,
    [Orientation.LANDSCAPE]: 10,
  },
};
